import React from 'react';
import PropTypes from 'prop-types';
import Content from '../UI/Content';
import InvestmentAssets from '../UI/ClientProfile/InvestmentAssets/Controller';
import LegacyAssets from '../UI/ClientProfile/LegacyAssets/Controller';
import LifeInsurance from '../UI/ClientProfile/LifeInsurance';
import RetirementIncome from '../UI/ClientProfile/RetirementIncome';
import RealAssets from '../UI/ClientProfile/RealAssets/Controller';
import Debts from '../UI/ClientProfile/Debts/Controller';
import BusinessInterests from '../UI/ClientProfile/BusinessInterests/Controller';
import '../UI/ClientProfile/ClientProfile.css';

const ClientProfile = ({
  lifeInsuranceAccounts,
  definedPensionPlans,
  socialSecurityBenefits,
  isAgent,
}) => (
  <Content className="no-side-padding">
    <InvestmentAssets />
    <LegacyAssets />
    <LifeInsurance lifeInsuranceAccounts={lifeInsuranceAccounts} isAgent={isAgent} />
    <RetirementIncome
      definedPensionPlans={definedPensionPlans}
      socialSecurityBenefits={socialSecurityBenefits}
      isAgent={isAgent}
    />
    <Debts />
    <RealAssets isAgent={isAgent} />
    <BusinessInterests isAgent={isAgent} />
  </Content>
);

ClientProfile.propTypes = {
  lifeInsuranceAccounts: PropTypes.array.isRequired,
  definedPensionPlans: PropTypes.array.isRequired,
  socialSecurityBenefits: PropTypes.array.isRequired,
  isAgent: PropTypes.bool.isRequired,
};

export default ClientProfile;
